module.exports = __webpack_public_path__ + "static/ogrod-6ddf82f5759d518813dd55cd4f05e198.jpg";